// Lightweight, no-double-fire conversion tracking.
// Fires to GA4 (gtag), Google Tag Manager (dataLayer) and PostHog if present.
// Safe no-op when no analytics is configured.
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...params });
    }
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, params);
    }
  } catch (e) {
    /* never break UX for analytics */
  }
}
